import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import { SignupPageComponent } from './pages/signup-page/signup-page.component';
import { ReserveMainPageRoutingModule } from './pages/reserve-main/reserve-main-routing.module';
import { MyReservesComponent } from './pages/my-reserves/my-reserves.component';
import { IsLoggedInGuard } from './auth/guards/is-logger-in/is-logged-in.guard';
import { MyCommissionsComponent } from './pages/my-commissions/my-commissions.component';
import { MyWalletComponent } from './pages/my-wallet/my-wallet.component';
import { RedirectComponent } from './redirect.component';
import { HasRoleGuard } from './auth/guards/has-roles/has-role.guard';
import { LockerLocationPage } from './components/reserve/locker-location/locker-location.page';

const routes: Routes =[
    {
      path: 'locker-location', 
      component: LockerLocationPage,
    },
    { 
      path: 'reserve',          
      loadChildren: () => ReserveMainPageRoutingModule 
    },
    { 
      path: 'signin',           
      component: SignupPageComponent 
    },
    { 
      path: 'signup',           
      component: SignupPageComponent 
    },
    { 
      path: 'reset',            
      component: SignupPageComponent 
    },
    { 
      path: 'reserves',         
      component: MyReservesComponent, 
      canActivate: [IsLoggedInGuard], canLoad: [IsLoggedInGuard] 
    },
    { 
      path: 'my-commissions',   
      component: MyCommissionsComponent, 
      canActivate: [IsLoggedInGuard], canLoad: [IsLoggedInGuard, HasRoleGuard], 
      data: {allowedRoles: ['ROLE_COMMISSION_AGENT']} 
    },
    { 
      path: 'my-wallet',        
      component: MyWalletComponent, 
      canActivate: [IsLoggedInGuard], canLoad: [IsLoggedInGuard] 
    },
    { 
      path: 'r/:shortUrl',      
      component: RedirectComponent 
    },
    { 
      path: '**', 
      redirectTo: 'locker-location', 
      pathMatch: 'full' 
    }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes,{
      useHash: false
    })
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
